import { render, staticRenderFns } from "./SideMenuNovel.vue?vue&type=template&id=b2f544d4&scoped=true&"
import script from "./SideMenuNovel.vue?vue&type=script&lang=ts&"
export * from "./SideMenuNovel.vue?vue&type=script&lang=ts&"
import style0 from "./SideMenuNovel.vue?vue&type=style&index=0&id=b2f544d4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2f544d4",
  null
  
)

export default component.exports